import './EmptyState.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var actionsSlotCss = '_1os652u9-3-5-0';
export var contentContainerCss = '_1os652u6-3-5-0';
export var detailsSlotCss = '_1os652u8-3-5-0';
export var emptyStateContainerCss = _7a468({defaultClassName:'_1os652u0-3-5-0',variantClassNames:{size:{small:'_1os652u1-3-5-0','default':'_1os652u2-3-5-0',large:'_1os652u3-3-5-0',largeResponsive:'_1os652u4-3-5-0'}},defaultVariants:{},compoundVariants:[]});
export var footerSlotCss = '_1os652ua-3-5-0';
export var titleSlotCss = '_1os652u7-3-5-0';
export var visualSlotCss = '_1os652u5-3-5-0';